import { Vue, Component } from 'vue-property-decorator';
import { sessionService } from '@/providers/services/auth/session';
import { appConfigService } from '@/providers/services/app/app-config';

@Component
export default class StaticAssetsMixin extends Vue {
    private session: any = sessionService.getSession();
    private get navigatorBasePath() {
        return appConfigService.getNavigatorBasePath();
    }
    private get staticImageUrl() {
        return appConfigService.getStaticImageUrl();
    }

    public getAssets(cdnUrl: any, fileName: any) {
        const cdnUrls = sessionService.getCdnUrl();
        let baseUrl = cdnUrl && cdnUrl.content_cdn_url;
        if (cdnUrls) {
            baseUrl = cdnUrls && cdnUrls.content_cdn_url;
        }
        const navigatorBasePath = this.navigatorBasePath;
        const staticImageUrl: any = this.staticImageUrl;
        const assetUrl = `${baseUrl}${navigatorBasePath}/${staticImageUrl[fileName]}`;
        return assetUrl;
    }
}
